import { render, staticRenderFns } from "./UnitGroups.vue?vue&type=template&id=a8022236&scoped=true&"
import script from "./UnitGroups.vue?vue&type=script&lang=js&"
export * from "./UnitGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8022236",
  null
  
)

export default component.exports